import { useLocation } from 'react-router-dom';
import { ScheduleMonthSwitcher } from '@/components/ScheduleMonthSwitcher/ScheduleMonthSwitcher';
import { ProjectsFiltersNavbarControl } from '@/components/Layout/ProjectsFiltersNavbarControl';
import { ProjectsSearchNavbarControl } from '@/components/Layout/ProjectsSearchNavbarControl';
import { ScheduleSearchNavbarControl } from '@/components/Layout/ScheduleSearchNavbarControl';
import { ReadersFiltersNavbarControl } from '@/components/Layout/ReadersFiltersNavbarControl';
import { ReadersSearchNavbarControl } from '@/components/Layout/ReadersSearchNavbarControl';
import { StudiosSearchNavbarControl } from '@/components/Layout/StudiosSearchNavbarControl';
import { NavbarAppMenu } from '@/components/Layout/NavbarAppMenu';
import { NavbarUserMenu } from '@/components/Layout/NavbarUserMenu';
import { ChatFab } from '@/components/Messenger/fab/ChatFab';
import { NavbarProjectUndoRedo } from '@/components/Layout/NavbarProjectUndoRedo';
import { NavbarSessionUndoRedo } from '@/components/Layout/NavbarSessionUndoRedo';
import { ToNewDesignButton } from '@/features/newdesign/ToNewDesignButton';
import './Navbar.css';

interface NavbarProps {
  onAddProject?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onAddPerson?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onOpenMiniAppPanel?: () => void;
  scheduleYear?: number;
  scheduleMonth?: number;
  onScheduleMonthChange?: (year: number, month: number) => void;
}

export function Navbar({
  onAddProject,
  onAddPerson,
  onOpenMiniAppPanel,
  scheduleYear = new Date().getFullYear(),
  scheduleMonth = new Date().getMonth(),
  onScheduleMonthChange,
}: NavbarProps) {
  const location = useLocation();
  const isSchedule = location.pathname === '/schedule';
  const isReadersRoute = location.pathname === '/readers';
  const isStudiosRoute = location.pathname === '/studios';
  const isProjectsRoute =
    location.pathname === '/' || location.pathname === '/projects';

  return (
    <nav className="navbar">
      <div className="navbar__left">
        <NavbarAppMenu
          onAddProject={onAddProject}
          onAddPerson={onAddPerson}
          onOpenMiniAppPanel={onOpenMiniAppPanel}
        />
        {isProjectsRoute ? (
          <div className="navbar__projects-toolbar">
            <ProjectsFiltersNavbarControl />
            <ProjectsSearchNavbarControl />
            <span className="navbar__toolbar-separator" aria-hidden="true" />
            <NavbarProjectUndoRedo />
          </div>
        ) : null}
        {isSchedule ? (
          <div className="navbar__projects-toolbar">
            <ScheduleSearchNavbarControl />
            <span className="navbar__toolbar-separator" aria-hidden="true" />
            <NavbarSessionUndoRedo />
          </div>
        ) : null}
        {isReadersRoute ? (
          <div className="navbar__projects-toolbar">
            <ReadersFiltersNavbarControl />
            <ReadersSearchNavbarControl />
          </div>
        ) : null}
        {isStudiosRoute ? (
          <div className="navbar__projects-toolbar">
            <StudiosSearchNavbarControl />
          </div>
        ) : null}
      </div>
      <div className="navbar__center">
        {isSchedule && onScheduleMonthChange && (
          <ScheduleMonthSwitcher
            year={scheduleYear}
            month={scheduleMonth}
            onMonthChange={onScheduleMonthChange}
          />
        )}
      </div>
      <div className="navbar__right">
        {/* В новом интерфейсе пока есть только проекты — переход туда предлагаем только со страницы проектов */}
        {isProjectsRoute ? <ToNewDesignButton /> : null}
        <ChatFab />
        <NavbarUserMenu />
      </div>
    </nav>
  );
}
